"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.verifyTransferLeg = void 0;
const isAirportTransfer_ClientComplete_1 = require("./isAirportTransfer_ClientComplete");
const isAreaTransfer_ClientComplete_1 = require("./isAreaTransfer_ClientComplete");
const isGolfTransfer_ClientComplete_1 = require("./isGolfTransfer_ClientComplete");
const verifyTransferLeg = (leg) => {
    let from_valid = true;
    let to_valid = true;
    switch (leg.from_type) {
        case "Airport": {
            from_valid = (0, isAirportTransfer_ClientComplete_1.isAirportTransfer_ClientComplete)(leg.from_details);
            break;
        }
        case "Area": {
            from_valid = (0, isAreaTransfer_ClientComplete_1.isAreaTransfer_ClientComplete)(leg.from_details);
            break;
        }
        case "Course": {
            from_valid = (0, isGolfTransfer_ClientComplete_1.isGolfTransfer_ClientComplete)(leg.from_details);
            break;
        }
    }
    if (!from_valid)
        return false;
    switch (leg.to_type) {
        case "Airport": {
            to_valid = (0, isAirportTransfer_ClientComplete_1.isAirportTransfer_ClientComplete)(leg.to_details);
            break;
        }
        case "Area": {
            to_valid = (0, isAreaTransfer_ClientComplete_1.isAreaTransfer_ClientComplete)(leg.to_details);
            break;
        }
        case "Course": {
            to_valid = (0, isGolfTransfer_ClientComplete_1.isGolfTransfer_ClientComplete)(leg.to_details);
            break;
        }
    }
    return to_valid && from_valid;
};
exports.verifyTransferLeg = verifyTransferLeg;
